/**
 * Sprint 22 — compaction lifecycle bar (ported from Sprint 6.2). Surfaces when
 * a long conversation is auto-compacted server-side.
 */
import { useEffect, useState } from "react";
import type { CompactionStatus } from "../../../hooks/use-chat-compaction";

interface CompactionIndicatorProps {
  status: CompactionStatus;
}

export function CompactionIndicator({ status }: CompactionIndicatorProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (status === "started") {
      setVisible(true);
    } else if (status === "completed") {
      setVisible(true);
      const timer = setTimeout(() => setVisible(false), 1000);
      return () => clearTimeout(timer);
    } else {
      setVisible(false);
    }
  }, [status]);

  if (!visible) return null;

  return (
    <div className="flex items-center gap-2 px-4 py-2 text-sm text-white/40">
      <div className="relative h-1 w-24 overflow-hidden rounded-full bg-white/10">
        {status === "started" && (
          <div className="absolute inset-y-0 left-0 w-1/2 animate-pulse rounded-full bg-accent-400/50" />
        )}
        {status === "completed" && (
          <div className="absolute inset-y-0 left-0 w-full rounded-full bg-accent-400/30" />
        )}
      </div>
      <span>
        {status === "started" ? "Compacting conversation…" : "Context refreshed"}
      </span>
    </div>
  );
}
